export default function handleSubnav() {
    document.querySelectorAll(".js-subnav-dropdown").forEach((dropdown) => {
      dropdown.addEventListener("change", function (e) {
        window.location.href = e.target.value;
      });
    });
  }
  